import { render, staticRenderFns } from "./DebitCreditTotalGroup.vue?vue&type=template&id=71cde948&scoped=true&"
import script from "./DebitCreditTotalGroup.vue?vue&type=script&lang=js&"
export * from "./DebitCreditTotalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cde948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71cde948')) {
      api.createRecord('71cde948', component.options)
    } else {
      api.reload('71cde948', component.options)
    }
    module.hot.accept("./DebitCreditTotalGroup.vue?vue&type=template&id=71cde948&scoped=true&", function () {
      api.rerender('71cde948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/AccountBook/components/DebitCreditTotalGroup.vue"
export default component.exports